/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminImpersonateRequest
 */
export interface AdminImpersonateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateRequest
     */
    codeChallenge: string;
}

/**
 * Check if a given object implements the AdminImpersonateRequest interface.
 */
export function instanceOfAdminImpersonateRequest(value: object): value is AdminImpersonateRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('codeChallenge' in value) || value['codeChallenge'] === undefined) return false;
    return true;
}

export function AdminImpersonateRequestFromJSON(json: any): AdminImpersonateRequest {
    return AdminImpersonateRequestFromJSONTyped(json, false);
}

export function AdminImpersonateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminImpersonateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'codeChallenge': json['codeChallenge'],
    };
}

export function AdminImpersonateRequestToJSON(json: any): AdminImpersonateRequest {
    return AdminImpersonateRequestToJSONTyped(json, false);
}

export function AdminImpersonateRequestToJSONTyped(value?: AdminImpersonateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'codeChallenge': value['codeChallenge'],
    };
}

